// src/utils/statusStyles.js

export function getStatusColor(id) {
    const map = {
      1: 'bg-blue-100',
      3: 'bg-yellow-100',
      4: 'bg-orange-100',
      5: 'bg-green-100',
      6: 'bg-red-100',
    };
    return map[id] || 'bg-gray-100';
  }
  
  export function getStatusTextColor(id) {
    const map = {
      1: 'text-blue-700',
      3: 'text-yellow-700',
      4: 'text-orange-700',
      5: 'text-green-700',
      6: 'text-red-700',
    };
    return map[id] || 'text-gray-700';
  }
  
  export function getStatusIcon(id) {
    const map = {
      1: '🆕',
      3: '⏳',
      4: '🔧',
      5: '✅',
      6: '❌',
    };
    return map[id] || '📌';
  }
  